import { useTranslation, Trans } from "next-i18next";
import CardIcon from "./cards/card-icon";
import "./styles/_mw-why-this.module.scss";

const OurSolutions = () => {
  const { t } = useTranslation("home");

  return (
    <section className="mw-why-this">
      <div className="container">
        <div className="section-tag testimonial pd-right mr-top">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="2.77778" fill="#5B5FC7"></rect><path d="M13.0677 10.2292C13.1419 10.114 13.2012 10.0294 13.2556 9.9398C13.6633 9.26366 14.0637 8.5824 14.4912 7.90882C14.5691 7.77195 14.686 7.66348 14.8259 7.59835C14.9657 7.53321 15.1216 7.51462 15.2721 7.54513C15.4178 7.56791 15.5519 7.64054 15.6531 7.75147C15.7543 7.8624 15.8168 8.00525 15.8306 8.15725C15.8452 8.34119 15.8074 8.52553 15.7219 8.6874C15.053 9.83308 14.3709 10.9711 13.6757 12.1014C13.3445 12.6392 12.6872 12.6136 12.3659 12.0502C11.973 11.3868 11.5998 10.7107 11.2168 10.0422C11.1649 9.95004 11.1081 9.86296 11.0315 9.73491L10.7596 10.1805C10.3939 10.7978 10.0182 11.415 9.6525 12.0348C9.28676 12.6546 8.58987 12.6648 8.21672 12.0066C7.79661 11.269 7.37897 10.5289 6.94403 9.76308C6.87978 9.86296 6.82541 9.94236 6.77846 10.0192C6.36824 10.6953 5.96295 11.374 5.54284 12.0476C5.49213 12.1346 5.42527 12.2103 5.34614 12.2703C5.26701 12.3303 5.17718 12.3734 5.08186 12.3972C4.98653 12.421 4.8876 12.4249 4.7908 12.4088C4.69399 12.3927 4.60123 12.3568 4.51788 12.3033C4.43454 12.2498 4.36226 12.1797 4.30524 12.097C4.24823 12.0143 4.2076 11.9208 4.18571 11.8217C4.16381 11.7227 4.1611 11.6201 4.17772 11.52C4.19434 11.4198 4.22995 11.3241 4.28251 11.2383C4.94151 10.1353 5.61121 9.03486 6.29163 7.93699C6.35955 7.8024 6.46243 7.69018 6.58864 7.613C6.71486 7.53581 6.85939 7.49675 7.00591 7.50021C7.15242 7.50367 7.29508 7.54953 7.41777 7.63259C7.54047 7.71566 7.6383 7.83263 7.70023 7.97028C8.07339 8.62337 8.4416 9.28159 8.80981 9.93468C8.86171 10.0269 8.91855 10.114 8.99021 10.2318L10.2456 8.15212C10.3 8.06248 10.3519 7.96772 10.4161 7.88064C10.4894 7.7616 10.5916 7.66451 10.7123 7.59904C10.833 7.53356 10.9682 7.50197 11.1044 7.50741C11.2406 7.51285 11.373 7.55512 11.4885 7.63003C11.6041 7.70495 11.6987 7.80989 11.7629 7.93443C12.146 8.59264 12.5043 9.25854 12.8898 9.92187C12.9392 10.0166 12.9936 10.1063 13.0677 10.2292Z" fill="white"></path><path d="M13.0851 9.14447C13.3875 8.63988 13.6947 8.1273 14.0159 7.62091C14.1496 7.39214 14.3493 7.20745 14.5913 7.09473C14.8345 6.98145 15.1067 6.94745 15.3704 6.99827C15.6385 7.04309 15.8816 7.17769 16.0635 7.37702C16.2479 7.5791 16.3593 7.83638 16.3839 8.10701L16.3844 8.11321L16.3844 8.11322C16.4073 8.40139 16.3482 8.69113 16.213 8.94699L16.2075 8.95737L16.2016 8.96751C15.5306 10.1169 14.8463 11.2585 14.1489 12.3925L14.1487 12.3927C13.8906 12.8119 13.4647 13.0622 12.9954 13.0439C12.5321 13.0258 12.1273 12.7504 11.8858 12.3297C11.6266 11.8921 11.3733 11.4443 11.1234 11.0025C11.0898 10.9431 11.0562 10.8838 11.0228 10.8247C10.9211 10.9948 10.8204 11.1627 10.7199 11.3301C10.5242 11.6563 10.3294 11.9809 10.131 12.3172C9.87048 12.7586 9.43925 13.0598 8.93272 13.0555C8.42409 13.0512 7.99441 12.7406 7.73373 12.2812C7.48829 11.8502 7.243 11.4172 6.99497 10.9793C6.97113 10.9372 6.94726 10.8951 6.92337 10.8529C6.62562 11.3458 6.32535 11.8427 6.01802 12.3355C5.9315 12.4815 5.81761 12.61 5.68182 12.7129L5.34614 12.2703L5.68182 12.7129C5.54349 12.8178 5.38536 12.8941 5.21633 12.9362C5.04726 12.9784 4.87152 12.9854 4.69958 12.9568C4.52766 12.9282 4.3639 12.8647 4.2177 12.7708L13.0851 9.14447ZM13.0851 9.14447C12.9943 8.98369 12.9039 8.82228 12.8131 8.65993L12.8102 8.65487C12.6269 8.32734 12.4413 7.9959 12.2493 7.66565C12.1417 7.46283 11.9845 7.2895 11.7908 7.1639C11.5925 7.03531 11.3635 6.96176 11.1266 6.9523C10.8896 6.94283 10.6554 6.99791 10.4475 7.11066C10.2467 7.21954 10.0782 7.37793 9.95573 7.56916C9.89335 7.65623 9.83599 7.75348 9.7972 7.81924C9.78695 7.83663 9.77799 7.85181 9.77058 7.86402L9.76998 7.86502L9.00014 9.14032M13.0851 9.14447L9.00014 9.14032M9.00014 9.14032C8.99922 9.13869 8.9983 9.13705 8.99738 9.13541C8.73153 8.6629 8.46397 8.18732 8.1942 7.71498C8.09029 7.49685 7.93055 7.30885 7.72923 7.17255C7.51933 7.03045 7.27331 6.95082 7.01903 6.94481C6.76474 6.9388 6.51518 7.00673 6.29882 7.13903C6.0905 7.26642 5.92184 7.44793 5.80824 7.66235C5.13056 8.75603 4.46347 9.85227 3.80697 10.9511L9.00014 9.14032Z" stroke="white" stroke-opacity="0.3" stroke-width="1.11111"></path></svg>
          {t("home.whyUs.tag")}
        </div>
        <h2>
          <Trans
            ns="home"
            i18nKey="home.whyUs.title"
            components={{
              highlight: <span className="text-gradient" />,
            }}
          />
        </h2>
        <div className="d-flex">
          <CardIcon
            imgWidth={212}
            imgHeight={228}
            title={t("home.whyUs.feature1.title")}
            icon="/images/ingest-everything.svg"
            description={t("home.whyUs.feature1.description")}
            quality={60}
          />

          <CardIcon
            imgWidth={212}
            imgHeight={228}
            title={t("home.whyUs.feature2.title")}
            icon="/images/installation-in-minute.svg"
            description={t("home.whyUs.feature2.description")}
            quality={60}
          />

          <CardIcon
            imgWidth={212}
            imgHeight={228}
            title={t("home.whyUs.feature3.title")}
            icon="/images/unified-telemetry-data.svg"
            description={t("home.whyUs.feature3.description")}
            quality={60}
          />

          <CardIcon
            imgWidth={212}
            imgHeight={228}
            title={t("home.whyUs.feature4.title")}
            icon="/images/better-correlation.svg"
            description={t("home.whyUs.feature4.description")}
            quality={60}
          />

          <CardIcon
            imgWidth={212}
            imgHeight={228}
            title={t("home.whyUs.feature5.title")}
            icon="/images/visualise-data-with-ai.svg"
            description={t("home.whyUs.feature5.description")}
            quality={60}
          />

          <CardIcon
            imgWidth={212}
            imgHeight={228}
            title={t("home.whyUs.feature6.title")}
            icon="/images/ai-sre-root.svg"
            description={t("home.whyUs.feature6.description")}
            quality={60}
          />
        </div>
      </div>
    </section>
  );
};

export default OurSolutions;
